import { render, staticRenderFns } from "./EditSchedule.vue?vue&type=template&id=70c71d5c"
import script from "./EditSchedule.vue?vue&type=script&lang=js"
export * from "./EditSchedule.vue?vue&type=script&lang=js"
import style0 from "./EditSchedule.vue?vue&type=style&index=0&id=70c71d5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports